// Prefer native H.264/AAC MP4 so saved lessons play in ordinary video players.
export function chooseRecordingMimeType(recorderClass, { hasAudio = true, requireMp4 = false } = {}) {
  const mp4 = hasAudio
    ? ['video/mp4;codecs=avc1.42E01E,mp4a.40.2', 'video/mp4;codecs=avc1,mp4a.40.2', 'video/mp4']
    : ['video/mp4;codecs=avc1.42E01E', 'video/mp4;codecs=avc1', 'video/mp4'];
  const webm = hasAudio
    ? ['video/webm;codecs=vp9,opus', 'video/webm;codecs=vp8,opus', 'video/webm']
    : ['video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm'];
  const selected = [...mp4, ...(requireMp4 ? [] : webm)].find(type => recorderClass.isTypeSupported(type));
  if (!selected) {
    const error = new Error(requireMp4
      ? 'MP4 recording is not supported on this setup. Please use the latest Learn With Ryan desktop app.'
      : 'Video recording is not supported on this setup.');
    error.code = 'RECORDING_FORMAT_UNSUPPORTED';
    throw error;
  }
  return selected;
}

export function recordingExtension(mimeType) {
  return /^video\/mp4(?:;|$)/i.test(mimeType) ? 'mp4' : 'webm';
}
